module.exports = __webpack_public_path__ + "media/images/top3-5bbefeb148a9075927d02cc6e52e79c3.png";